/**
 * Used to add hover interaction with opacity to an element.
 */
export const opacity = (
  start: number,
  end = 1,
): {
  transition: string;
  opacity: number;
  ':hover': {
    opacity: number;
  };
} => ({
  transition: 'all 0.1s ease-in-out',
  opacity: start,
  ':hover': {
    opacity: end,
  },
});

/**
 * Used to make an element clickable.
 */
export const clickable = (
  hoverColor = 'transparent',
  activeColor = 'transparent',
): {
  transition: string;
  cursor: string;
  backgroundColor: string;
  ':hover': {
    backgroundColor: string;
  };
  ':active': {
    backgroundColor: string;
  };
} => ({
  cursor: 'pointer',
  transition: 'all 0.1s ease-in-out',
  backgroundColor: 'transparent',
  ':hover': {
    backgroundColor: hoverColor,
  },
  ':active': {
    backgroundColor: activeColor,
  },
});

/** Reusable html styles. */
export const htmlStyles = {
  position: 'relative',
  color: 'text',
  a: {
    color: 'primary',
    textDecoration: 'none',
  },
  p: {
    color: 'text',
    mb: 3,
  },
  span: {
    color: 'text',
  },
  h3: {
    my: 3,
    color: 'text',
  },
  h4: {
    my: 0,
    mr: 1,
    color: 'text',
  },
};
